<script lang="ts">
	interface Props {
		height?: string; // Default height
		width?: string; // Default width
		class?: string;
	}

	let { height = '48px', width = '48px', class: className = '' }: Props = $props();
	
</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	fill="none"
	viewBox="0 0 48 48"
	{height}
	{width}
	class={className}
	><path
		d="M42 22.586h-16v-16h-4v16H6v4h16v16h4v-16h16v-4z"
		fill="currentColor"
		stroke-width="2"
	/></svg
>
